export default function Privacy() {
  return (
    <div className="pb-20 pt-4">
      <div className="container mx-auto px-4 max-w-2xl">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Privacy Policy
        </h2>

        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 border border-gray-200 dark:border-gray-700 space-y-4">
          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              1. Information We Collect
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              BaseVibe is a decentralized application. We collect minimal information:
            </p>
            <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
              <li>Wallet addresses (public blockchain data)</li>
              <li>Vote history (stored on-chain)</li>
              <li>Local storage data (streak information, preferences)</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              2. How We Use Information
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Your wallet address is used only to process votes on the blockchain. 
              Local storage is used to track your streak and preferences on your device only.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              3. Blockchain Transparency
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              All votes are recorded on the Base blockchain and are publicly visible. 
              Anyone can view voting patterns associated with wallet addresses.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              4. Data Storage
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              We store data in two ways:
            </p>
            <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
              <li><strong>On-chain:</strong> Vote data stored permanently on Base blockchain</li>
              <li><strong>Local:</strong> Streak and preferences stored in your browser only</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              5. Third-Party Services
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              BaseVibe integrates with wallet providers and Base network. 
              Their privacy policies apply to their services.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              6. Your Rights
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              You can clear local data at any time through Settings. 
              On-chain data cannot be deleted due to blockchain immutability.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              7. Cookies
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              We do not use tracking cookies. Only essential browser storage is used for app functionality.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              8. Contact
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              For privacy concerns, please open an issue on our GitHub repository.
            </p>
          </section>

          <div className="text-xs text-gray-500 dark:text-gray-400 pt-4 border-t border-gray-200 dark:border-gray-700">
            Last updated: November 6, 2025
          </div>
        </div>
      </div>
    </div>
  )
}

